import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Neutral = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Neutral} />;

export default Neutral;
